import * as yup from "yup";

export const valuesAndErrorsToFields = (values, errors) =>
  Object.keys(values).reduce(
    (acc, key) => ({
      ...acc,
      [key]: {
        value: values[key],
        errors: errors[key],
      },
    }),
    {}
  );

export const validateJsonObject = (rule, value, callback) => {
  try {
    yup.object().strict().cast(value);
    return callback();
  } catch (e) {
    return callback("invalid json");
  }
};

export const prettyPrintJSONString = (value) => {
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch (e) {
    return value;
  }
};
